"use client"

import { getProductsByCategory } from "@/lib/api/dutchie"
import CategoryLayout, { CategoryConfig } from "@/components/shop/CategoryLayout"
import type { ProductDisplay } from "@/lib/api/dutchie"

const CATEGORY = "apparel"

const categorizeApparel = (product: ProductDisplay): string => {
  const name = (product.name || '').toLowerCase()
  const is716Canna = product.name === '716 Canna Co.'

  if (name.includes("hat") || name.includes("cap") || name.includes("beanie") || is716Canna) return "Headwear"
  if (name.includes("t shirt") || name.includes("tshirt") || name.includes("t-shirt")) return "T-Shirts"
  if (name.includes("hoodie") || name.includes("sweatshirt")) return "Hoodies"

  return product.subcategory && product.subcategory !== "DEFAULT" ? product.subcategory : "Other"
}

const fetchProducts = async (): Promise<ProductDisplay[]> => {
  try {
    const apparel = await getProductsByCategory("apparel")
    const accessories = await getProductsByCategory("accessories")
    const filteredAccessories = accessories.filter(p => p.name === "716 Canna Co.")
    const merged = [...apparel, ...filteredAccessories].filter(p => p.inStock)

    const deduped = Object.values(
      merged.reduce((acc, p) => {
        if (p.id) acc[p.id] = p
        return acc
      }, {} as Record<string, ProductDisplay>)
    )

    return deduped.map(p => ({
      ...p,
      virtualSubcategory: categorizeApparel(p)
    }))
  } catch (err) {
    console.error("Error fetching apparel:", err)
    return []
  }
}

const config: CategoryConfig = {
  title: "Apparel",
  blurb: "Browse our selection of premium cannabis apparel and lifestyle gear.",
  fetch: fetchProducts,
  virtualSubcategory: categorizeApparel,
  showPotency: false,
  filterInStock: true,
  showWeight: false,
  headerTheme: "purple", // Purple for lifestyle/apparel brand
  extraFilterChips: (p: ProductDisplay) => ({
    Brands: p.brand ? [p.brand] : []
  }),
  debug: true
}

export default function ApparelPage() {
  return (
    <CategoryLayout
      config={config}
      productCardProps={{ buttonClassName: "bg-purple-600 hover:bg-purple-700" }}
    />
  )
}